import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AddEditPageComponent, AddEditPageModule } from '@app/views/pages/add-edit-page/add-edit-page.component';
import { PageCenterModule } from '@app/views/pages/page-center/page-center.component';
import { PageComponent, PageModule } from '@app/views/pages/page/page.component';
import { NewsPageResolver } from '@app/views/pages/page/page.resolver';
import { ContentPageCenterViewComponent, ContentPageCenterViewModule } from './content-page-center-view/content-page-center-view.component';
import { NewsCenterViewComponent, NewsCenterViewModule } from './news-center-view/news-center-view.component';
import { ContentPageResolver } from './page/page.resolver';
import { Roles } from '@app/common/roles';
import { AuthorizeAccessGuard } from '@app/guards/authorize-access.guard';

@NgModule({
  imports: [
    RouterModule.forChild(
      [
        {
          path: 'content', component: ContentPageCenterViewComponent,
        },
        {
          path: 'content/add', component: AddEditPageComponent, canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
        },
        {
          path: 'content/:slugWithId', component: PageComponent, resolve: { page: ContentPageResolver }
        },
        {
          path: 'content/:slugWithId/edit', component: AddEditPageComponent, resolve: { page: ContentPageResolver }, canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
        },
        {
          path: 'news', component: NewsCenterViewComponent,
        },
        {
          path: 'news/add', component: AddEditPageComponent, canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
        },
        {
          path: 'news/:slugWithId', component: PageComponent, resolve: { page: NewsPageResolver }
        },
        {
          path: 'news/:slugWithId/edit', component: AddEditPageComponent, resolve: { page: NewsPageResolver }, canActivate: [AuthorizeAccessGuard], data: { roles: [Roles.Admin, Roles.Editor] }
        }
      ]),
    PageModule,
    PageCenterModule,
    AddEditPageModule,
    NewsCenterViewModule,
    ContentPageCenterViewModule
  ]
})
export class PagesViewModule { }
